import { render, staticRenderFns } from "./LayoutDefaultSideBar.vue?vue&type=template&id=703e791c&scoped=true&"
import script from "./LayoutDefaultSideBar.vue?vue&type=script&lang=ts&"
export * from "./LayoutDefaultSideBar.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutDefaultSideBar.vue?vue&type=style&index=0&id=703e791c&prod&lang=scss&scoped=true&"
import style1 from "./LayoutDefaultSideBar.vue?vue&type=style&index=1&id=703e791c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703e791c",
  null
  
)

export default component.exports